export enum HEADER_VARIANTS {
  HUGE = "huge",
  DEFAULT = "default",
  MINIMAL = "minimal",
  NONE = "none",
}
